<template>
    <div>

        <section id="main-area">
            <div class="container" style="padding-top: 45px">
                <bb-reservation-main></bb-reservation-main>
            </div>
        </section>
    </div>
</template>

<script>
    import { mdbModal, mdbModalBody, mdbBtn } from 'mdbvue';
    import findFlight from '@/components/findFlight';
    import reservationBar from '@/components/reservationBar';
    import reservationMain from '@/components/reservationMain';

    export default {
        components: {
            mdbModal,
            mdbModalBody,
            mdbBtn,
            'bb-findflight':findFlight,
            'bb-reservationbar':reservationBar,
            'bb-reservation-main':reservationMain,
        },
        data() {
            return {
                modal: false,
                toggle: false,
            };
        }
    };
</script>

<style scoped>

</style>
